import React from 'react';
import classnames from 'classnames';

import s from './BlurredBackground.scss';

export interface Props {
  imageUrl: string;
  clientSideBlur?: boolean;
}

export const BlurredBackground: React.FC<Props> = ({ imageUrl, clientSideBlur = false }) => {
  return (
    <div className={s['root']}>
      <div
        className={classnames(s['image'], clientSideBlur && s['image-blurred'])}
        style={{
          backgroundImage: `url('${imageUrl}')`,
        }}
      />
    </div>
  );
};
BlurredBackground.displayName = 'BlurredBackground';

export default BlurredBackground;
